import * as ents from '@attain-apps/entities'
import * as store from '@attain-apps/fe/web/main/lib/store'
import { TypeChecker } from '@attain-apps/type-guards'
import * as rxjs from 'rxjs'

import type { Collection } from '../../collection'
import { Selection } from '../../models'
import type { Feature } from '../feature'

/** Submits the selected file through the collection's operation feature. */
export const submitUpload = store.effects.create(
  (feature: Feature, collection: Collection) =>
    feature.actions.upload.observe().pipe(
      rxjs.withLatestFrom(
        feature.selectors.selectedFile.asObservable,
        feature.selectors.mode.asObservable,
        feature.selectors.selectedDataSource.asObservable,
        feature.selectors.target.asObservable,
        collection.fileOperations.selectors.isUploading.asObservable,
      ),
      rxjs.mergeMap(([action, file, mode, dataSource, target, uploading]) => {
        if (!TypeChecker.isNotNullish(file) || uploading) {
          return rxjs.EMPTY
        }

        const input =
          mode === Selection.Mode.Agent && TypeChecker.isNotNullish(dataSource)
            ? {
                dataSourceId: dataSource.id,
                knowledgeBaseId: dataSource.knowledgeBaseId,
                name: file.name,
                sizeBytes: file.size,
              }
            : mode === Selection.Mode.Shared &&
                (ents.core.agent.KnowledgeBase.Target.Tenant.isTenant(target) ||
                  ents.core.agent.KnowledgeBase.Target.Zone.isZone(target))
              ? {
                  name: file.name,
                  sizeBytes: file.size,
                  target,
                }
              : undefined
        if (!input) {
          return rxjs.EMPTY
        }

        return rxjs.of(
          collection.fileOperations.actions.upload.from(action).create({
            file,
            input,
          }),
        )
      }),
    ),
)
